import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const StockLedgerService = {
  getOnHandMap: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.StockLedger}/on-hand`);
      return response.data;
    } catch (error) {
      console.error("Error fetching on-hand map:", error.message);
      throw error;
    }
  },
};